import React, { useEffect, useState } from 'react';
import { prefersReducedMotion } from 'src/utils/motion';

export type Testimonial = { quote: string; author: string };

interface Props {
  items: Testimonial[];
  intervalMs?: number;
}

const TestimonialCarousel = ({ items, intervalMs = 8000 }: Props) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  // Rotation is motion nobody asked for, so it follows the same setting as the shader.
  const still = prefersReducedMotion();

  useEffect(() => {
    if (still || paused || items.length < 2) return;
    const timer = setInterval(() => setIndex((current) => (current + 1) % items.length), intervalMs);
    return () => clearInterval(timer);
  }, [still, paused, items.length, intervalMs]);

  if (items.length === 0) return null;

  const active = items[index];

  return (
    <div
      className="onboarding-testimonial"
      data-testid="testimonial-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      {/* Polite, not assertive: this is ambient content beside a form the user is
          filling in, and it must not interrupt what a screen reader is announcing. */}
      <blockquote className="onboarding-testimonial__quote" aria-live="polite" data-testid="testimonial-quote">
        {active.quote}
      </blockquote>
      <p className="onboarding-testimonial__author">{active.author}</p>

      {items.length > 1 && (
        <div className="onboarding-testimonial__dots">
          {items.map((item, dot) => (
            <button
              key={item.quote}
              type="button"
              className="onboarding-testimonial__dot"
              data-testid={`testimonial-dot-${dot}`}
              aria-current={dot === index}
              aria-label={item.author}
              onClick={() => setIndex(dot)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TestimonialCarousel;
